export default "__VITE_ASSET__DEdaukJq__"